import { AssetMetadata } from '../models/Asset';
import DescriptionIcon from '@mui/icons-material/Description';
import FileDownloadComponent from '../../content/components/lesson_components/FileDownloadComponent';
import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import Typography from '@mui/material/Typography';
import { fileSize } from 'humanize-plus';
import styles from '../styles/AssetView.module.css';

interface AssetContentViewProps {
  assetUrl: string;
  assetMetadata: AssetMetadata;
}

export function AssetContentView(props: AssetContentViewProps) {
  const { contentType, filename, size } = props?.assetMetadata;

  const assetUrl = props?.assetUrl;

  if (contentType?.startsWith('image')) {
    return (
      <div className={styles.mediaContainer}>
        <img
          className={styles.media}
          src={assetUrl}
          alt="" //* to not show a broken icon on 404 error
        />
      </div>
    );
  }

  if (contentType?.startsWith('video')) {
    return (
      <>
        <div className={styles.videoContainer}>
          <video className={styles.video} controls src={assetUrl} />
        </div>
      </>
    );
  }

  if (contentType?.startsWith('audio')) {
    return (
      <div className={styles.mediaContainer}>
        <audio src={assetUrl} controls className={styles.media} />
      </div>
    );
  }

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid>
        <DescriptionIcon fontSize="large" />
      </Grid>

      {assetUrl ? (
        <>
          <Grid>
            <Typography variant="caption">
              {decodeURIComponent(filename)}
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="caption">{fileSize(size)}</Typography>
          </Grid>
          <FileDownloadComponent url={assetUrl} filename={filename} />
        </>
      ) : (
        <Grid>
          <Typography variant="caption">No file chosen</Typography>
        </Grid>
      )}
    </Grid>
  );
}
